export enum YesNoEnum {
    YES = 'Yes',
    NO = 'No'
}
